import Component from '../abstracts/Component';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default class PriceRangeComponent extends Component {
  get SELECTORS() {
    return {
      minInput: '[data-input-min]',
      minText: '[data-text-min]',
      maxInput: '[data-input-max]',
      maxText: '[data-text-max]',
      rangeSlider: '[data-range-slider]',
      resetBtn: '[data-range-reset]',
      //END WIP
      rangerBar: '.price-range',
      inputMin: '.input-min',
      inputMax: '.input-max',
      activeMin: '#selectedValueMin',
    };
  }

  get CSS_CLASSNAMES() {
    return {
      minValueSet: 'c-p-r__min-value-set',
      maxValueSet: 'c-p-r__max-value-set',
      //END WIP
      active: 'active',
    };
  }

  constructor(compEl) {
    super(compEl);
  }

  readDOM() {
    return {
      minVal:parseInt(document.querySelector(this.SELECTORS.rangerBar)?.dataset.rangeMin),
      maxVal: parseInt(document.querySelector(this.SELECTORS.rangerBar)?.dataset.rangeMax),
      currentMin: parseInt(document.querySelector(this.SELECTORS.rangerBar)?.dataset.min),
      currentMax: parseInt(document.querySelector(this.SELECTORS.rangerBar)?.dataset.max),
      minText: document.querySelector(this.SELECTORS.minText),
      maxText: document.querySelector(this.SELECTORS.maxText),
      minInput: document.querySelector(this.SELECTORS.minInput),
      maxInput: document.querySelector(this.SELECTORS.maxInput),
      resetBtn: document.querySelector(this.SELECTORS.resetBtn),
      rangeSlider: document.querySelector(this.SELECTORS.rangeSlider),
      rangerBar: document.querySelector(this.SELECTORS.rangerBar),
      inputMin: document.querySelector(this.SELECTORS.inputMin),
      inputMax: document.querySelector(this.SELECTORS.inputMax),
    }
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.init();
    this.setSliderChangeHandler();
  }

  init() {
    this.updateTexts();
    this.updateInputs();
    noUiSlider.create(this.dom.rangeSlider, {
      start: [this.dom.currentMin, this.dom.currentMax],
      connect: true,
      range: {
        min: this.dom.minVal,
        max: this.dom.maxVal,
      },
      step: 10,
      format: {
        from: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
        to: function (value) {
          return Number(value)
            .toString()
            .replace('.-', '');
        },
      },
    });
    const handles = this.dom.rangeSlider.querySelectorAll('.noUi-handle');

    handles.forEach((handle, index) => {
      // for accessibility nav + screen reader
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-valuemin', this.dom.minVal);
      handle.setAttribute('aria-valuemax', this.dom.maxVal);
      handle.setAttribute('aria-orientation', 'horizontal');
      handle.setAttribute('aria-label', index === 0 ? 'Min Price' : 'Max Price');
    });

  }

  renderNewSlider() {
    this.dom = this.readDOM();
    if (this.dom.rangeSlider.noUiSlider && this.dom.rangeSlider.noUiSlider != 'undefined') {
      this.dom.rangeSlider.noUiSlider.destroy();
    }
    this.init();
    this.setSliderChangeHandler();
  }

  setSliderChangeHandler() {
    this.dom.rangeSlider.noUiSlider.on('update', () => {
      var values = this.dom.rangeSlider.noUiSlider.get();
      // noUiSlider sometimes returns value with 0.0000001 difference (eg 239.99999), avoid it by rounding up
      this.dom.currentMin = Math.round(parseFloat(values[0]));
      this.dom.currentMax = Math.round(parseFloat(values[1]));
      this.updateTexts();
      this.updateInputs();
      this.toggleResetVisibility(this.isSliderChanged(this.dom.rangeSlider));
    });
    this.dom.resetBtn.addEventListener('click', this.resetSlider.bind(this));
  }

  isSliderChanged(rangeSlider) {
    this.dom = this.readDOM();
    if (rangeSlider == null) {
      // price filter not present in page (ex. algolia search)
      return false;
    }
    var values = rangeSlider.noUiSlider.get();
    this.dom.currentMin = parseInt(values[0]);
    this.dom.currentMax = parseInt(values[1]);

    return this.dom.currentMin !== this.dom.minVal || this.dom.currentMax !== this.dom.maxVal;
  }

  updateTexts() {
    this.dom.minText.innerHTML = this.dom.currentMin.toString().replace('.-', '');
    this.dom.maxText.innerHTML = this.dom.currentMax.toString().replace('.-', '');
    if (this.dom.currentMin == this.dom.minVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.minValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.minValueSet);
    }
    if (this.dom.currentMax == this.dom.maxVal) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.maxValueSet);
    } else {
      this.$component.classList.add(this.CSS_CLASSNAMES.maxValueSet);
    }
  }

  updateInputs() {
    this.dom.minInput.value = this.dom.currentMin.toString().replace('.-', '');
    this.dom.maxInput.value = this.dom.currentMax.toString().replace('.-', '');
  }

  resetSlider() {
    this.dom = this.readDOM();
    if (!this.dom.rangeSlider) {
      return;
    }
    if (this.dom.rangerBar !== null) {
      this.dom.minVal = parseInt(this.dom.rangerBar.dataset.rangeMin);
      this.dom.maxVal = parseInt(this.dom.rangerBar.dataset.rangeMax);
      this.dom.rangeSlider.noUiSlider.set([this.dom.minVal, this.dom.maxVal]);
    }
    this.toggleResetVisibility(false);
  }

  toggleResetVisibility(show) {
    if (show) {
      this.dom.resetBtn.style.opacity = 1;
    } else {
      this.dom.resetBtn.style.opacity = 0;
    }
  }

  //END WIP
  getAllRanges(element) {
    if (element != null) {
      // let's take data
      let data = element.dataset;
      // vars
      let all = data["all"];
      let allSplitted = all.split("|");
      // ascending order set
      const sortAsc = (a, b) => a - b;
      allSplitted.sort(sortAsc);
      //
      return allSplitted;
    }
  }

  buildQuery(isReset) {
    this.dom = this.readDOM();
    // take values
    if (this.dom.rangerBar == null) {
      return '';
    }
    let allSplitted = this.getAllRanges(this.dom.rangerBar);

    let minVal = this.dom.rangerBar.querySelector('[data-input-min]').value;
    let maxVal = this.dom.rangerBar.querySelector('[data-input-max]').value;
    let rangeMin = this.dom.rangerBar.getAttribute("data-range-min");
    let rangeMax = this.dom.rangerBar.getAttribute("data-range-max");
    let facetName = this.dom.rangerBar.getAttribute("data-facet-name");

    let query = '';
    let count;

    if ((rangeMin !== minVal || rangeMax !== maxVal) && !isReset
      && (minVal != "" && maxVal != "") // mobile price filter deselect case (basically a reset)
    ){
      query = ':';
      for (var i = 0; i < allSplitted.length; i++) {
        if (parseInt(allSplitted[i]) <= parseInt(minVal) && !(i === 0 && allSplitted[i] === minVal && minVal === rangeMin)) {
          // if is less (or NOT: first and equal to min values) jump it
          continue;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count == null) {
          // first price filter
          query += facetName + ":" + allSplitted[i];
          count = 1;
        } else if ((parseInt(allSplitted[i]) <= maxVal) && count != null) {
          // first price filter
          query += ":" + facetName + ":" + allSplitted[i];
        } else {
          break;
        }
      }
      if (query === ':') {
        //avoids broken query
        query += facetName + ":" + maxVal;
      }
    } else {
      query = '';
    }
    return query;
  }

}
